(function () {
    'use strict';

    angular
        .module('vm')
        .factory('AlertsService', AlertsService);

    function AlertsService ($timeout) {
        const alerts = [];
        const callbacks = [];

        return {
            getAlerts: getAlerts,
            add: add,
            remove: remove,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
        };

        //////////////

        function getAlerts() {
            return alerts;
        }

        function add(alert) {
            alerts.push(alert);
            sendAlertsUpdateEvent();

            if (alert.closeDelay !== -1) {
                $timeout(() => {
                    remove(alert);
                }, alert.closeDelay ? alert.closeDelay : 3000);
            }
        }

        function remove(alert) {
            const alertIndex = alerts.indexOf(alert);

            if (alertIndex !== -1) {
              alerts.splice(alertIndex, 1);
              sendAlertsUpdateEvent();
            }
        }

        function sendAlertsUpdateEvent() {
            angular.forEach(callbacks, (callback) => {
                callback(alerts);
            });
        }

        function subscribe(callback) {
            callbacks.push(callback);
        }

        function unsubscribe(callback) {
            const callbackIndex = callbacks.indexOf(callback);

            if (callbackIndex !== -1) {
                callbacks.splice(callbackIndex, 1);
            }
        }
    }
}());